export default {
  eyebrow: 'Partnerportal',
  title: 'Verarbeitungsgebühren',
  description:
    'Sie tragen die Stripe-Gebühren für jede Online-Zahlung. Die hier festgelegte Verarbeitungsgebühr wird Ihren Restaurants berechnet, um diese zu decken, sofern ein Restaurant keinen eigenen Satz hat.',
  card_title: 'Standard-Verarbeitungsgebühr',
  hint: 'Prozentsatz in %, dazu optional ein fester und ein Mindestbetrag pro Zahlung. „Alle Zahlungsarten“ greift, wenn kein artspezifischer Satz existiert. Eine Änderung gilt für Zahlungen nach dem Speichern.',
  hint_single:
    'Die Verarbeitungsgebühr gilt für jede Online-Zahlungsart ohne eigenen Satz. Eine Änderung gilt für Zahlungen nach dem Speichern.',
  hidden_rates:
    'Für einige Zahlungsarten gilt außerdem ein eigener Satz, den Ihr Plattform-Support festgelegt hat. Er gilt dort anstelle dieses Satzes.',
  empty: {
    title: 'Keine Standard-Verarbeitungsgebühr festgelegt',
    description:
      'Bis Sie eine festlegen oder bestätigen, dass Sie Ihren Restaurants keine Verarbeitungsgebühr berechnen, können Ihre Restaurants auf Stripe nicht live gehen, und live geschaltete nehmen keine Online-Zahlungen an (Barzahlung funktioniert weiter).',
  },
  consent: {
    give: 'Wir tragen die Stripe-Gebühren selbst (0 % Marge bestätigen)',
    given_title: '0 % Marge bestätigt',
    given:
      'Bestätigt von {{name}} am {{date}}: Restaurants ohne eigenen Satz wird keine Verarbeitungsgebühr berechnet, und Sie tragen die Stripe-Gebühren für deren Zahlungen.',
    unknown_manager: 'einem ehemaligen Manager',
    withdraw: 'Widerrufen',
    withdraw_confirm: {
      title: 'Bestätigung der Marge von 0 % widerrufen?',
      description:
        'Restaurants ohne eigenen Satz können dann nicht live gehen, und live geschaltete nehmen keine Online-Zahlungen mehr an, bis Sie einen Satz festlegen oder erneut bestätigen.',
    },
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  toasts: {
    load_error: 'Ihre Verarbeitungsgebühren konnten nicht geladen werden.',
    failed_to_save_changes: 'Ihre Verarbeitungsgebühren konnten nicht gespeichert werden.',
    changes_got_saved: 'Verarbeitungsgebühren gespeichert',
    consent_given: '0 % Marge bestätigt',
    consent_withdrawn: 'Bestätigung widerrufen',
  },
};
